export default __webpack_public_path__ + "static/media/cook1.739e62eb.PNG";